// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"e5a43904256a57be4d5b","777":"2874eb49c00e84677aa3"}[chunkId] + ".chunk.js";
};